import { render, staticRenderFns } from "./ExternalMapLayerSetup.vue?vue&type=template&id=c4f924ce&scoped=true"
import script from "./ExternalMapLayerSetup.vue?vue&type=script&lang=ts"
export * from "./ExternalMapLayerSetup.vue?vue&type=script&lang=ts"
import style0 from "./ExternalMapLayerSetup.vue?vue&type=style&index=0&id=c4f924ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f924ce",
  null
  
)

export default component.exports